import OnlineOpinionForm from './OnlineOpinionForm';
export default OnlineOpinionForm;